import Skeleton, { SkeletonTheme } from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';

interface SkeletonLoaderProps {
  count: number;
  height: number;
}

const SkeletonLoader = ({ count, height }: SkeletonLoaderProps) => {
  const baseColor = getComputedStyle(document.documentElement).getPropertyValue(
    '--white',
  );
  const highlightColor = getComputedStyle(
    document.documentElement,
  ).getPropertyValue('--neutral-light-2');

  return (
    <SkeletonTheme baseColor={baseColor} highlightColor={highlightColor}>
      <p>
        <Skeleton
          count={count}
          height={height}
          style={{ borderRadius: '0px' }}
        />
      </p>
    </SkeletonTheme>
  );
};

export { SkeletonLoader };
